import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline'
import NotesSection from '../NotesSection'
import IncidentsSection from '../IncidentsSection'

interface EodSession {
  id: number
  general_notes: string | null
  notes_for_tomorrow: string | null
  incidents: any[]
}

interface IncidentsNotesStepProps {
  session: EodSession
  canLog: boolean
  onSessionUpdate: (updated: any) => void
  onNext: () => void
  onBack: () => void
  isFirst: boolean
}

const IncidentsNotesStep = ({
  session,
  canLog,
  onSessionUpdate,
  onNext,
  onBack,
  isFirst,
}: IncidentsNotesStepProps) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-lg font-semibold text-gray-900">Incidents &amp; notes</h2>
      <p className="mt-1 text-sm text-gray-500">
        Flag anything worth noting from today's service and leave a handover for tomorrow.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="rounded-lg border border-gray-200 bg-white p-5">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">Incidents</h3>
        <IncidentsSection
          session={session}
          canLog={canLog}
          onUpdate={onSessionUpdate}
        />
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-5">
        <h3 className="text-sm font-semibold text-gray-900 mb-4">Notes</h3>
        <NotesSection
          session={session}
          canLog={canLog}
          onUpdate={onSessionUpdate}
        />
      </div>
    </div>

    <div className="flex items-center justify-between pt-2 border-t border-gray-100">
      <button
        onClick={onBack}
        disabled={isFirst}
        className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-30"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        Back
      </button>
      <button
        onClick={onNext}
        className="inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-500"
      >
        Next
        <ArrowRightIcon className="h-4 w-4" />
      </button>
    </div>
  </div>
)

export default IncidentsNotesStep
